import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PublicPageGuard implements CanActivate {

  constructor(private router: Router) {}


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // Vérifier si l'utilisateur est authentifié
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    const userRole = localStorage.getItem('role') || sessionStorage.getItem('role');
    
    if (token && userRole) {
      // Utilisateur authentifié : rediriger vers le dashboard approprié selon le rôle
      this.redirectToDashboardByRole(userRole);
      return false;
    }

    // Utilisateur non authentifié : autoriser l'accès aux pages publiques
    return true;
  }
  
   private redirectToDashboardByRole(role: string): void {
    switch (role) {
      case 'adm':
        this.router.navigate(['/dashboard'], { replaceUrl: true });
        break;
      case 'asst':
        this.router.navigate(['/dash'], { replaceUrl: true });
        break;
      case 'cmrc':
        this.router.navigate(['/mydash'], { replaceUrl: true });
        break;
      case 'support':
        this.router.navigate(['/dash-support'], { replaceUrl: true });
        break;
      case 'adm-MF':
        this.router.navigate(['/administration'], { replaceUrl: true });
        break;
      default:
        this.router.navigate(['/dashboard'], { replaceUrl: true });
        break;
    }
  }
}
